// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2328":"5a4e36c3","5727":"bf0d1105","6081":"77d222d3"}[chunkId] + ".chunk.css";
};